import React from 'react'
import {message} from 'antd'
import {Link} from 'react-router-dom'
import Header from './header'
import ydLogo from '@assets/img/ydIcon.png'
import './index.less'

export default function CockpitOverview({
  history,

}) {
  return (
    <div className="ck-overview">
      <Header history={history} />
      <div className="ck-title">
        勇电智慧照明管理云平台
        <span class="empty-sp" />
      </div>
      <div className="ck-project">
        <div className="ck-ball ball-1"
          onClick={() => {
            message.info("敬请期待")
          }}
        >
          <div className="ck-content">
            设备资产
          </div>
          <div className="ball-in animation-in" />
          <div className="ball-mid animation-mid" />
          <div className="ball-out1 animation-out1" />
          <div className="ball-out2 animation-out2" />
        </div>
        <div className="ck-ball ball-2"
          onClick={() => {
            message.info("敬请期待")
          }}
        >
          <div className="ck-content">
            智慧运维
          </div>
          <div className="ball-in animation-in" />
          <div className="ball-mid animation-mid" />
          <div className="ball-out1 animation-out1" />
          <div className="ball-out2 animation-out2" />
        </div>
        <div className="ck-ball ball-3"
          onClick={() => {
            message.info("敬请期待")
          }}
        >
          <div className="ck-content">
            AI互动
          </div>
          <div className="ball-in animation-in" />
          <div className="ball-mid animation-mid" />
          <div className="ball-out1 animation-out1" />
          <div className="ball-out2 animation-out2" />
        </div>
        <Link className="ck-ball ball-4"
          to="/cockpit/energyStatistics"
        >
          <div className="ck-content">
            智慧强电
          </div>
          <div className="ball-in animation-in" />
          <div className="ball-mid animation-mid" />
          <div className="ball-out1 animation-out1" />
          <div className="ball-out2 animation-out2" />
        </Link>
        <Link className="ck-ball ball-5"
          to="/cockpit/realtimeMonitor"
        >
          <div className="ck-content">
            智慧安防
          </div>
          <div className="ball-in animation-in" />
          <div className="ball-mid animation-mid" />
          <div className="ball-out1 animation-out1" />
          <div className="ball-out2 animation-out2" />
        </Link>
        <Link className="ck-ball ball-6"
          to="/cockpit/lightControl"
        >
          <div className="ck-content">
            智慧灯光
          </div>
          <div className="ball-in animation-in" />
          <div className="ball-mid animation-mid" />
          <div className="ball-out1 animation-out1" />
          <div className="ball-out2 animation-out2" />
        </Link>
        <Link
          className="ck-ball ball-7"
          to="/cockpit/index"
        >
          <div className="ck-content">
            数据驾驶舱
          </div>
          <div className="ball-in animation-in" />
          <div className="ball-mid animation-mid" />
          <div className="ball-out1 animation-out1" />
          <div className="ball-out2 animation-out2" />
        </Link>
      </div>
      <div className="yd-logo">
        <img src={ydLogo} alt="" className="yd-logo-img" />
      </div>
    </div>
  )
}